import $ from 'jquery';

const menu = {
	init: function () {
		// trigger function when DOM is ready
		window.addEventListener('load', function () {
			console.log('Menu functionality loaded!');
			const mobileWidth = 1080;

			//* Find all menu items and add tabindex 0 to them
			$('.main-menu > .menu-item > a').attr('tabindex', '0');

			// A wide mega-menu panel with little content (e.g. a dropdown
			// with just one link) is mostly empty space that isn't part of
			// the trigger's own hit area, so fast or diagonal mouse
			// movement toward that link can momentarily leave both the
			// trigger and the panel. Closing immediately on that made the
			// menu close before the mouse ever reached the link. A short
			// delay — cancelled if the mouse re-enters the trigger or
			// panel in time — fixes that without changing how it looks.
			let closeSubmenuTimeout;

			const clearCloseSubmenuTimeout = () => {
				if (closeSubmenuTimeout) {
					clearTimeout(closeSubmenuTimeout);
					closeSubmenuTimeout = null;
				}
			};

			const addSubmenuExpandedClass = function () {
				// console.log("addSubmenuExpandedClass");
				clearCloseSubmenuTimeout();
				// Moving directly from one open item to another only
				// cancels that item's pending close (below) — it never
				// actually ran removeSubmenuExpandedClass, so the previous
				// item was left expanded at the same time as this new one,
				// rendering both panels on top of each other. Switching
				// items should close the old one immediately.
				$('.main-menu > .menu-item.submenu-expanded').not(this).removeClass('submenu-expanded');
				$('header').addClass('submenu-expanded');
				$(this).addClass('submenu-expanded');
				$(this).parentsUntil('.main-menu').last().addClass('submenu-expanded');
			};

			const removeSubmenuExpandedClass = () => {
				// console.log("removeSubmenuExpandedClass");
				clearCloseSubmenuTimeout();
				closeSubmenuTimeout = setTimeout(() => {
					$('header').removeClass('submenu-expanded');
					$('.submenu-expanded').removeClass('submenu-expanded');
				}, 300);
			};

			//* MOBILE MENU *//
			const $mobileMenuToggle = $('#nav-toggle');

			const expandMobileMenu = (event) => {
				const parent = $(event.currentTarget).parent(); // menu-item
				const menuHasChildren = parent.hasClass('menu-item-has-children');
				if (!menuHasChildren) return;

				event.preventDefault && event.preventDefault();

				// Remove any existing ready-to-expand classes
				$('.ready-to-expand').removeClass('ready-to-expand');

				parent.addClass('ready-to-expand');
				parent
					.parentsUntil('.main-menu', '.menu-item')
					.addClass('mobile-child-menu-expanded');

				const siblingMenuItems = parent.siblings();

				siblingMenuItems.each(function (index, item) {
					$(item).addClass('mobile-sibling-menu-expanded');
				});
			};

			const collapseMobileMenu = function (event) {
				const parent = $(event.currentTarget).parent(); // menu-item
				$('.ready-to-expand').removeClass('ready-to-expand');

				const openMenuDepth = parent.parentsUntil(
					'.main-menu',
					'.mobile-child-menu-expanded'
				);
				parent
					.parentsUntil('.main-menu', '.menu-item')
					.removeClass('mobile-child-menu-expanded');

				const siblingMenuItems = parent.siblings();

				siblingMenuItems.each(function (index, item) {
					$(item).removeClass('mobile-sibling-menu-expanded');
				});

				if (openMenuDepth.length > 0) {
					expandMobileMenu({
						currentTarget: openMenuDepth.last().children('a'),
						target: openMenuDepth.last().children('a')
					});
				}
			};

			//* create function that collapses all mobile menus
			const collapseAllMobileMenus = function () {
				$('.mobile-child-menu-expanded').removeClass('mobile-child-menu-expanded');
				$('.mobile-sibling-menu-expanded').removeClass('mobile-sibling-menu-expanded');
				$('.ready-to-expand').removeClass('ready-to-expand');

				//* Detach any existing back buttons
				$('.mobile-menu-back-button').detach();
			};

			const createMobileBackButton = function (event) {
				const parent = $(event.target).parent(); // menu-item
				const headerNav = $('header .header-nav');

				// Create new back button in headerNav element
				const buttonSvg = `<svg width="98" height="92" viewBox="0 0 98 92" fill="black" xmlns="http://www.w3.org/2000/svg">
					<rect y="0.354736" width="97.6846" height="91.6453" fill="white"/>
					<g opacity="0.5" fill=black>
					<path d="M29.536 46.6288C28.7549 47.4098 28.7549 48.6761 29.536 49.4572L42.2639 62.1851C43.045 62.9662 44.3113 62.9662 45.0923 62.1851C45.8734 61.4041 45.8734 60.1377 45.0923 59.3567L33.7786 48.043L45.0923 36.7293C45.8734 35.9482 45.8734 34.6819 45.0923 33.9008C44.3113 33.1198 43.045 33.1198 42.2639 33.9008L29.536 46.6288ZM30.9502 50.043H73.704V46.043H30.9502V50.043Z" fill="black"/>
					</g>
					</svg>`;

				const backButton = $(
					`<div class="mobile-menu-back-button" title="Go Back">${buttonSvg}</div>`
				);

				//* Grab all existing back buttons
				const existingBackButtons = headerNav.find('.mobile-menu-back-button');

				//* Hide all existing back buttons add required aria tags
				existingBackButtons.each(function (index, item) {
					$(item).attr('aria-hidden', 'true');
					$(item).attr('tabindex', '-1');
				});

				//* Show new back button and add required aria tags
				backButton.attr('aria-hidden', 'false');
				backButton.attr('tabindex', '0');

				//* Append new back button to headerNav
				headerNav.append(backButton);

				const handleMobileMenuBackButtonClick = () => {
					collapseMobileMenu(event);
					backButton.detach();

					//* Find all existing back buttons and show the last one and add required aria tags
					const existingBackButtons = headerNav.find('.mobile-menu-back-button');
					existingBackButtons.last().attr('aria-hidden', 'false');
					existingBackButtons.last().attr('tabindex', '0');

					parent.children('a').focus();
				};

				backButton.on('click', handleMobileMenuBackButtonClick);
				backButton.on('keydown', function (event) {
					if (event.keyCode === 13) {
						handleMobileMenuBackButtonClick(event);
					}
				});
			};

			const handleMobileMenuClick = function (event) {
				const parent = $(this).parent(); // menu-item

				if (parent.hasClass('ready-to-expand')) {
					//* do something on second click, normally links to link page
				} else {
					createMobileBackButton(event);
					expandMobileMenu(event);
				}
			};

			// Is Mobile
			if (this.window.innerWidth < mobileWidth) {
				console.log($('.main-menu').find('.menu-item').children('a'));
				$('.main-menu').find('.menu-item').children('a').on('click', handleMobileMenuClick);
			} else {
				$('.main-menu').children().on('mouseenter', addSubmenuExpandedClass);
				$('.main-menu').children().on('mouseleave', removeSubmenuExpandedClass);
				$('.main-menu > .menu-item > .sub-menu')
					.children()
					.find('a')
					.on('focus', addSubmenuExpandedClass);
				$('.main-menu > .menu-item > .sub-menu')
					.children()
					.find('a')
					.on('blur', removeSubmenuExpandedClass);
			}

			$mobileMenuToggle.on('click', function () {
				$('header').toggleClass('mobile-menu-expanded');
				collapseAllMobileMenus();
			});
			$mobileMenuToggle.on('keydown', function (event) {
				if (event.keyCode === 13) {
					$('header').toggleClass('mobile-menu-expanded');
					collapseAllMobileMenus();
				}
			});
		});
	},
	bindElements: function () {}
};

export default menu;
